import React, { useEffect, useState } from 'react';
import { C, S } from '../../utils/styles';
import Icon from '../Icon';
import { getGatingStatus } from './learnerApi';

// ----------------------------------------------------------------------------
// MandatoryTrainingBanner — soft, dismissible banner shown to Employers /
// Employees with incomplete required courses. AMs use a hard-block instead.
// ----------------------------------------------------------------------------

export default function MandatoryTrainingBanner({ onGoToTraining }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let mounted = true;
    getGatingStatus()
      .then((d) => { if (mounted) setStatus(d); })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!status || !status.blocked || status.isHardBlocked) return null;

  const list = status.incompleteMandatory || [];
  return (
    <div
      data-testid="mandatory-training-banner"
      style={{
        background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
        border: `1px solid ${C.orange}33`,
        borderRadius: 12,
        padding: '14px 18px',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        marginBottom: 16,
        flexWrap: 'wrap',
      }}
    >
      <Icon name="alert-circle-outline" style={{ fontSize: 28, color: C.orange, flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 200 }}>
        <div style={{ fontSize: 14, fontWeight: 800, color: '#92400e' }}>
          Required training awaits
        </div>
        <div style={{ fontSize: 12, color: '#78350f', marginTop: 2 }}>
          You have {list.length} required course{list.length === 1 ? '' : 's'} to complete:{' '}
          <strong>{list.map((c) => c.title).slice(0, 3).join(' · ')}</strong>
          {list.length > 3 ? ` and ${list.length - 3} more` : ''}
        </div>
      </div>
      <button
        type="button"
        data-testid="banner-go-to-training"
        onClick={onGoToTraining}
        style={{ ...S.buttonPrimary, background: C.orange, borderColor: C.orange, fontSize: 13 }}
      >
        Go to training
      </button>
    </div>
  );
}
